import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Building2, FolderOpen, Users, Activity, AlertCircle, TrendingUp } from 'lucide-react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line } from 'recharts';
import { useNavigate } from 'react-router-dom';
const builderData = [{
  name: 'Active',
  count: 24
}, {
  name: 'Trial',
  count: 8
}, {
  name: 'Inactive',
  count: 3
}];
const activityData = [{
  date: 'Mon',
  sessions: 340
}, {
  date: 'Tue',
  sessions: 298
}, {
  date: 'Wed',
  sessions: 420
}, {
  date: 'Thu',
  sessions: 380
}, {
  date: 'Fri',
  sessions: 290
}, {
  date: 'Sat',
  sessions: 180
}, {
  date: 'Sun',
  sessions: 210
}];
export function AdminDashboardPage() {
  const navigate = useNavigate();
  return <div className="space-y-8 max-w-7xl mx-auto" data-id="element-155">
      <div className="flex items-center justify-between" data-id="element-156">
        <div data-id="element-157">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-158">
            ResVR Admin Dashboard
          </h1>
          <p className="text-slate-500 mt-1" data-id="element-159">
            Platform overview and system health
          </p>
        </div>
        <div className="flex gap-3" data-id="element-160">
          <Button variant="outline" onClick={() => navigate('/admin/builders')} data-id="element-161">
            Manage Builders
          </Button>
          <Button onClick={() => navigate('/admin/projects')} data-id="element-162">
            View All Projects
          </Button>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-163">
        <Card data-id="element-164">
          <CardContent className="flex items-center p-6" data-id="element-165">
            <div className="p-3 bg-primary-50 rounded-lg" data-id="element-166">
              <Building2 className="h-6 w-6 text-primary-600" data-id="element-167" />
            </div>
            <div className="ml-4" data-id="element-168">
              <p className="text-sm font-medium text-slate-500" data-id="element-169">
                Active Builders
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-170">24</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-171">
                <span className="font-medium" data-id="element-172">+3</span>
                <span className="ml-1 text-slate-400" data-id="element-173">this month</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-174">
          <CardContent className="flex items-center p-6" data-id="element-175">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-176">
              <FolderOpen className="h-6 w-6 text-slate-600" data-id="element-177" />
            </div>
            <div className="ml-4" data-id="element-178">
              <p className="text-sm font-medium text-slate-500" data-id="element-179">
                Total Projects
              </p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-180">156</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-181">
                <span className="font-medium" data-id="element-182">+12</span>
                <span className="ml-1 text-slate-400" data-id="element-183">this month</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-184">
          <CardContent className="flex items-center p-6" data-id="element-185">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-186">
              <Users className="h-6 w-6 text-slate-600" data-id="element-187" />
            </div>
            <div className="ml-4" data-id="element-188">
              <p className="text-sm font-medium text-slate-500" data-id="element-189">Total Buyers</p>
              <h3 className="text-2xl font-bold text-slate-900" data-id="element-190">3,247</h3>
              <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-191">
                <span className="font-medium" data-id="element-192">+18%</span>
                <span className="ml-1 text-slate-400" data-id="element-193">vs last month</span>
              </p>
            </div>
          </CardContent>
        </Card>

        <Card data-id="element-194">
          <CardContent className="flex items-center p-6" data-id="element-195">
            <div className="p-3 bg-slate-100 rounded-lg" data-id="element-196">
              <Activity className="h-6 w-6 text-slate-600" data-id="element-197" />
            </div>
            <div className="ml-4" data-id="element-198">
              <p className="text-sm font-medium text-slate-500" data-id="element-199">
                Platform Health
              </p>
              <h3 className="text-lg font-bold text-green-600" data-id="element-200">Healthy</h3>
              <p className="text-xs text-slate-500 mt-1" data-id="element-201">99.8% uptime</p>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-202">
        {/* Activity Chart */}
        <Card className="lg:col-span-2" data-id="element-203">
          <CardHeader data-id="element-204">
            <CardTitle data-id="element-205">Platform Activity (Last 7 Days)</CardTitle>
          </CardHeader>
          <CardContent data-id="element-206">
            <div className="h-[300px] w-full" data-id="element-207">
              <ResponsiveContainer width="100%" height="100%" data-id="element-208">
                <LineChart data={activityData} data-id="element-209">
                  <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" data-id="element-210" />
                  <XAxis dataKey="date" tick={{
                  fill: '#64748b',
                  fontSize: 12
                }} data-id="element-211" />
                  <YAxis tick={{
                  fill: '#64748b',
                  fontSize: 12
                }} data-id="element-212" />
                  <Tooltip contentStyle={{
                  borderRadius: '8px',
                  border: 'none',
                  boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                }} data-id="element-213" />
                  <Line type="monotone" dataKey="sessions" stroke="#06b6d4" strokeWidth={2} dot={{
                  fill: '#06b6d4'
                }} data-id="element-214" />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </CardContent>
        </Card>

        {/* Builder Status */}
        <Card data-id="element-215">
          <CardHeader data-id="element-216">
            <CardTitle data-id="element-217">Builder Status</CardTitle>
          </CardHeader>
          <CardContent data-id="element-218">
            <div className="space-y-4" data-id="element-219">
              {builderData.map(item => <div key={item.name} className="flex items-center justify-between" data-id="element-220">
                  <span className="text-sm font-medium text-slate-700" data-id="element-221">
                    {item.name}
                  </span>
                  <div className="flex items-center gap-2" data-id="element-222">
                    <span className="text-2xl font-bold text-slate-900" data-id="element-223">
                      {item.count}
                    </span>
                    <Badge variant={item.name === 'Active' ? 'success' : item.name === 'Trial' ? 'warning' : 'neutral'} data-id="element-224">
                      {item.name}
                    </Badge>
                  </div>
                </div>)}
            </div>
            <div className="mt-6 pt-6 border-t border-slate-100" data-id="element-225">
              <Button variant="outline" className="w-full" onClick={() => navigate('/admin/builders')} data-id="element-226">
                View All Builders
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Recent Activity */}
      <Card data-id="element-227">
        <CardHeader data-id="element-228">
          <CardTitle data-id="element-229">Recent Builder Activity</CardTitle>
        </CardHeader>
        <CardContent data-id="element-230">
          <div className="space-y-4" data-id="element-231">
            <div className="flex items-start gap-4 pb-4 border-b border-slate-100" data-id="element-232">
              <div className="p-2 bg-green-50 rounded-lg" data-id="element-233">
                <TrendingUp className="h-4 w-4 text-green-600" data-id="element-234" />
              </div>
              <div className="flex-1" data-id="element-235">
                <p className="text-sm font-medium text-slate-900" data-id="element-236">
                  Acme Homes activated new project
                </p>
                <p className="text-xs text-slate-500 mt-1" data-id="element-237">
                  The Riverside Collection - 2 hours ago
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4 pb-4 border-b border-slate-100" data-id="element-238">
              <div className="p-2 bg-blue-50 rounded-lg" data-id="element-239">
                <Building2 className="h-4 w-4 text-blue-600" data-id="element-240" />
              </div>
              <div className="flex-1" data-id="element-241">
                <p className="text-sm font-medium text-slate-900" data-id="element-242">
                  New builder onboarded
                </p>
                <p className="text-xs text-slate-500 mt-1" data-id="element-243">
                  Summit Builders LLC - 5 hours ago
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-id="element-244">
              <div className="p-2 bg-amber-50 rounded-lg" data-id="element-245">
                <AlertCircle className="h-4 w-4 text-amber-600" data-id="element-246" />
              </div>
              <div className="flex-1" data-id="element-247">
                <p className="text-sm font-medium text-slate-900" data-id="element-248">
                  Support request submitted
                </p>
                <p className="text-xs text-slate-500 mt-1" data-id="element-249">
                  Horizon Developments - Options sync issue - 1 day ago
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>;
}